import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Subscription, of } from 'rxjs';
import { SeaculumAngularFormlyService } from '../../services/saeculum-angular-formly.service';
import { INFO_ICON } from '../../constant/common.constant';
import { FormBaseClass } from '../shared/base-class/form-base-class';

@Component({
    selector: 'saeculum-input-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss']
})
export class SelectComponent extends FormBaseClass implements OnInit, OnChanges {
    @Input() fieldObj: any;
    @Input() options: any = of([]);
    @Input() values;

    @Input() form: FormGroup;
    @Output() valueChange = new EventEmitter<any>();

    infoIcon = INFO_ICON.icon;
    filterText = '';

    selectAll = true;
    selectAllCheckbox = false;
    unSelectAllCheckbox = false;
    allOptions = [];

    constructor() {
        super();
    }

    ngOnInit() {
        this.getAllOptions(this.options);
        this.addControl();
        this.onValueChange();
    }

    addControl() {
        const value = this.values ? this.values[this.fieldObj.key] : null;
        this.form.addControl(this.fieldObj.key, new FormControl(value));
        this.setValidations(this.form, this.fieldObj);

        if (this.values && this.values[this.fieldObj.key] && this.values[this.fieldObj.key] === 'All') {
            this.onSelectAll();
        }

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.values && changes.values.currentValue && this.form.get(this.fieldObj.key)) {
            this.form.get(this.fieldObj.key).setValue(changes.values.currentValue);
        }

        if (changes && changes.options && changes.options.currentValue) {
            this.options = changes.options.currentValue;
            this.getAllOptions(this.options);
        }
    }

    getAllOptions(options) {
        // tslint:disable-next-line: no-unused-expression
        this.options && this.options.subscribe(data => {
            this.allOptions = data;
        });
        if (this.values && this.values[this.fieldObj.key] && this.values[this.fieldObj.key] === 'All') {
            this.onSelectAll();
        }
    }

    notifyChange() {
        this.valueChange.emit({ key: this.fieldObj.key, value: this.form.get(this.fieldObj.key).value });
    }

    onSelectAll() {
        if (this.form.get(this.fieldObj.key) && this.allOptions && this.allOptions.length) {
            const selected = this.allOptions.map(item => item[this.fieldObj.templateOptions.bindValue]);
            this.form.get(this.fieldObj.key).patchValue(selected);
            this.selectAll = false;
            this.selectAllCheckbox = false;
            this.unSelectAllCheckbox = true;
        }
    }

    onClearAll() {
        this.form.get(this.fieldObj.key).patchValue([]);
        this.selectAll = true;
        this.selectAllCheckbox = false;
        this.unSelectAllCheckbox = false;
    }

    onValueChange() {
        const selected = this.form.get(this.fieldObj.key) && this.form.get(this.fieldObj.key).value;
        if ((this.allOptions && selected) && this.allOptions.length === selected.length) {
            this.selectAll = false;
            this.selectAllCheckbox = false;
            this.unSelectAllCheckbox = true;
        } else {
            this.selectAll = true;
            this.selectAllCheckbox = false;
            this.unSelectAllCheckbox = false;
        }

    }

}
